/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./myToken.vue?vue&type=template&id=63013eef&scoped=true"
import script from "./myToken.vue?vue&type=script&lang=js"
export * from "./myToken.vue?vue&type=script&lang=js"
import style0 from "./myToken.vue?vue&type=style&index=0&id=63013eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63013eef",
  null
  
)

export default component.exports